import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddBatchComponent } from './add-batch/add-batch.component';
import { AddVehicleComponent } from './add-vehicle/add-vehicle.component';
import { BatchDetailsComponent } from './batch-details/batch-details.component';
import { InventoryMainComponent } from './inventory-main/inventory-main.component';
import { InventoryComponent } from './inventory.component';
import { NewComponent } from './new/new.component';
import { PurchaseComponent } from './purchase/purchase.component';
import { RetailsComponent } from './retails/retails.component';
import { VehicleDetailsComponent } from './vehicle-details/vehicle-details.component';

const routes: Routes = [
  {
    path: '',
    component: InventoryComponent,
    children: [
      {
        path: '',
        component: InventoryMainComponent,
        data: {
          title: 'Inventory',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '',
            },
          ],
        },
      },
      {
        path: 'add-new-vehicle',
        component: AddVehicleComponent,
        data: {
          title: 'Add New',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Add New',
              url: '',
            },
          ],
        },
      },
      {
        path: 'edit-vehicle/:vehicleId',
        component: AddVehicleComponent,
        data: {
          title: 'Edit vehicle',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Edit vehicle',
              url: '',
            },
          ],
        },
      },
      {
        path: 'add-new-batch',
        component: AddBatchComponent,
        data: {
          title: 'Add New Batch',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Add New Batch',
              url: '',
            },
          ],
        },
      },
      {
        path: 'edit-batch/:batchId',
        component: AddBatchComponent,
        data: {
          title: 'edit Batch',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'edit Batch',
              url: '',
            },
          ],
        },
      },
      {
        path: 'vehicle-details/:InventoryProductId',
        component: VehicleDetailsComponent,
        data: {
          title: 'Vehicle Details',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Vehicle Details',
              url: '',
            },
          ],
        },
      },
      {
        path: 'batch-details/:batchId',
        component: BatchDetailsComponent,
        data: {
          title: 'Batch Details',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Batch Details',
              url: '',
            },
          ],
        },
      },
      {
        path: 'retail',
        component: RetailsComponent,
        data: {
          title: 'Retail inventory',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Retail',
              url: '',
            },
          ],
        },
      },
      {
        path: 'purchase',
        component: PurchaseComponent,
        data: {
          title: 'Purchase inventory',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'Purchase',
              url: '',
            },
          ],
        },
      },
      {
        path: 'new',
        component: NewComponent,
        data: {
          title: 'New inventory',
          breadcrumb: [
            {
              label: 'Inventory',
              url: '../inventory',
            },
            {
              label: 'New',
              url: '',
            },
          ],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InventoryRoutingModule {}
